<template>
  <div class="margin-top">
    <div class="text-left mb-10">
      <el-button type="primary" size="small" @click="openAddModal">
        关联店铺
      </el-button>
    </div>

    <el-table :data="roleShopInfo.roleShops" border style="width: 100%">
      <el-table-column prop="shopId" label="店铺编号" align="center"></el-table-column>
      <el-table-column prop="shopName" label="店铺名称" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="openDeleteModal(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="mt-10" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>

    <add-role-shop ref="addRoleShop" @refresh="loadRoleShops"></add-role-shop>
    <delete-role-shop ref="deleteRoleShop" @refresh="loadRoleShops"></delete-role-shop>
  </div>
</template>

<script>
import AddRoleShop from '@/components/frame/addRoleShop/addRoleShop'
import DeleteRoleShop from '@/components/frame/deleteRoleShop/deleteRoleShop'
import { getRoleShopList } from '@/api/frame/roleShopApi'

export default {
  name: 'RoleShop',
  components: {
    AddRoleShop,
    DeleteRoleShop
  },
  data() {
    return {
      roleShopInfo: {
        roleShops: [],
        pgId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    openRoleShop(params) {
      this.roleShopInfo.pgId = params.pgId
      this.loadRoleShops()
    },
    async loadRoleShops() {
      try {
        const params = {
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          roleId: this.roleShopInfo.pgId
        }
        const res = await getRoleShopList(params)
        this.roleShopInfo.roleShops = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取店铺列表失败:', error)
      }
    },
    openAddModal() {
      this.$refs.addRoleShop.open({
        roleId: this.roleShopInfo.pgId
      })
    },
    openDeleteModal(roleShop) {
      this.$refs.deleteRoleShop.open(roleShop)
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadRoleShops()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadRoleShops()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 15px;
}

.text-left {
  text-align: left;
}

.mb-10 {
  margin-bottom: 10px;
}

.mt-10 {
  margin-top: 10px;
}
</style>